<template>
	<div v-if="mobile" class="drawer-wrapper">
		<aside ref="drawer" :class="{ show: isOpen }" class="drawer">
			<div class="drawer-header">
				<div class="avatar" />
				<div v-if="canDisplayUserInfo" class="title">
					<span v-if="userName">{{userName}}</span>
					<small v-if="userTitle">{{userTitle}}</small>
				</div>
			</div>

			<div class="drawer-body">
				<div class="drawer-body-top">
					<slot name="main-nav">
						<list />
					</slot>
				</div>

				<div v-if="$slots['footer']" class="drawer-body-bottom">
					<slot name="footer">
						<list />
					</slot>
				</div>
			</div>
		</aside>
		<div :class="{ show: isOpen }" class="drawer-backdrop" @click="closeDrawer" />
	</div>
</template>


<script>
    import { browser } from 'pdk/services';


	export default {
        name: 'custom-app-drawer',
		props: {
			userName: {
				type: String,
				default: null
			},
			userTitle: {
				type: String,
				default: null
			},
			open: {
				type: Boolean,
				default: false
            }
		},
        data() {
            return {
                mobile: browser.getBrowser().mobile
            };
        },
		computed: {
			canDisplayUserInfo() {
				return this.userName || this.userTitle;
            },
            isOpen() {
                return this.open && this.mobile;
            }
        },
		methods: {
			openDrawer() {
				this.$emit('open');
			},
			closeDrawer() {
				this.$emit('close');
			},
			navigate() {
				this.close();
            }
		}
	};
</script>
